import React from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import AvatarEditorPanel from "../../components/AvatarEditorPanel";
import MannequinPreview from "../../components/MannequinPreview";

export default function AvatarEditorPage({ avatar, setAvatar }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="avatar-split-page">
      <div className="account-mobile-tabs">
        <Link
          to="/account"
          className={`account-mobile-tab ${
            location.pathname === "/account" ? "is-active" : ""
          }`}
        >
          Account
        </Link>

        <Link
          to="/account/avatar"
          className={`account-mobile-tab ${
            location.pathname === "/account/avatar" ? "is-active" : ""
          }`}
        >
          Edit mannequin
        </Link>
      </div>

      <div className="avatar-split-top">
        <h1 className="avatar-page-title">Edit mannequin</h1>
        <div className="avatar-split-actions" />
      </div>

      <div className="avatar-split-grid">
        <div className="avatar-split-left">
          <AvatarEditorPanel
            open={true}
            avatar={avatar}
            setAvatar={setAvatar}
            onClose={() => navigate(-1)}
          />
        </div>

        <div className="avatar-split-right">
          <MannequinPreview avatarParams={avatar} view="front" />
        </div>
      </div>
    </div>
  );
}